import React from 'react';

export default function IndexSectionNumbersWhitePattern21() {
    return (
        <React.Fragment>
            <>
                <section className="py-20 xl:py-24 bg-white" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <span className="inline-block py-px px-2 mb-4 text-xl leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">PROCESS</span>
    <h3 className="mb-4 text-4xl md:text-5xl text-coolGray-900 font-bold tracking-tighter">Our Manufacturing Process</h3>
    <p className="mb-16 xl:mb-24 text-lg md:text-xl text-coolGray-500 font-medium max-w-3xl">At Bagga International, we combine four decades of experience with modern craftsmanship to create high-quality tool belts, tool bags, and accessories that professionals trust.</p>
    <div className="flex flex-wrap items-center -mx-4 text-center">
      <div className="w-full md:w-1/2 px-4 mb-16 md:mb-0">
        <div className="flex flex-wrap justify-center -mx-4">
          <div className="w-full md:w-1/2 px-4 mb-8">
            <h2 className="mb-4 text-4xl lg:text-5xl text-green-600 font-bold tracking-tighter"> Precision Engineering</h2>
            <p className="text-coolGray-500 font-medium">Each product is designed with durability and functionality in mind, using advanced manufacturing techniques.</p>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-8">
            <h2 className="mb-4 text-4xl lg:text-5xl text-green-600 font-bold tracking-tighter"> Premium Materials</h2>
            <p className="text-coolGray-500 font-medium">We source high-quality fabrics, leather, and reinforcements to ensure long-lasting performance.</p>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-8 md:mb-0">
            <h2 className="mb-4 text-4xl lg:text-5xl text-green-600 font-bold tracking-tighter">Durability Tested</h2>
            <p className="text-coolGray-500 font-medium">Each product is stress-tested to withstand tough working conditions.</p>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <h2 className="mb-4 text-4xl lg:text-5xl text-green-600 font-bold tracking-tighter">Efficiency &amp; Scale</h2>
            <p className="text-coolGray-500 font-medium">With a streamlined production process, we fulfill bulk orders while maintaining top-notch quality.</p>
          </div>
        </div>
      </div>
      <div className="w-full md:w-1/2 px-4">
        <img className="mx-auto md:mr-0" src="https://res.cloudinary.com/dgkoae5ks/image/upload/v1747714478/bagga-international/LDP-106.webp" alt="Bagga International Manufacturing Process" />
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

